import { useEffect, useState, useSyncExternalStore } from 'react';
import { dynamicCustomEventTracking } from '../../../../lib/gtm';
import {
  PrescriptionRenewalResponse,
  useListPrescriptionRenewalMutation
} from '../../../../services/prescriptionRenewal.service';
import PrescriptionRenewalModel from './model';

// Global (fora do React) — compartilhado por todas as instâncias montadas de PrescriptionRenewalViewModel,
// já que MyFilesV2 e ExamsV2 mantêm suas próprias instâncias montadas simultaneamente (ver HomeV2/index.tsx)
let hasPendingRequest = false;
let isFetching = false;
let pendingFetch: Promise<PrescriptionRenewalResponse[]> | null = null;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getHasPendingRequestSnapshot = () => hasPendingRequest;
const getIsFetchingSnapshot = () => isFetching;

const notify = () => listeners.forEach(listener => listener());

const setHasPendingRequest = (value: boolean) => {
  hasPendingRequest = value;
  notify();
};

const setIsFetching = (value: boolean) => {
  isFetching = value;
  notify();
};

export const resetPrescriptionRenewalPendingState = () => {
  hasPendingRequest = false;
  isFetching = false;
  pendingFetch = null;
  notify();
};

export default function PrescriptionRenewalViewModel() {
  const [listPrescriptionRenewal] = useListPrescriptionRenewalMutation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const pendingRequest = useSyncExternalStore(subscribe, getHasPendingRequestSnapshot);
  const isListing = useSyncExternalStore(subscribe, getIsFetchingSnapshot);

  const handleOpenModal = () => {
    dynamicCustomEventTracking.send({ dynamicEventName: 'solicitar_renovacao_pedido_mc' });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOrderCreated = (_order: PrescriptionRenewalResponse) => {
    setHasPendingRequest(true);
  };

  useEffect(() => {
    if (!pendingFetch) {
      setIsFetching(true);
      pendingFetch = listPrescriptionRenewal({ page: 1, quantity: 10 })
        .unwrap()
        .then(data => {
          if (PrescriptionRenewalModel.hasPendingRequest(data)) {
            setHasPendingRequest(true);
          }
          return data;
        })
        .catch(error => {
          console.error('Failed to fetch order renewal list:', error);
          return [];
        })
        .finally(() => {
          setIsFetching(false);
          pendingFetch = null;
        });
    }
  }, []);

  return {
    isModalOpen,
    isListing,
    hasPendingRequest: pendingRequest,
    handleOpenModal,
    handleCloseModal,
    handleOrderCreated
  };
}
